import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/Homepage.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/BCC-3.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/BCC-4.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/Biosafety-Cabinet-Calibration-3.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/CAT-3.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/CAT-4.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/CV-2.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/CV-3.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/CV-4.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/LACS-2.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/LACS-3.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/LACS-4.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/Laminar-Airflow-Calibration-1.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/OTV-3.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/OTV-4.webp");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/services1.jpg");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/services4.jpg");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/services5.jpg");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/services6.jpg");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/services7.jpg");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/services8.jpg");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/services-images/services9.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
